import type { I18nContextValue } from "../i18n/useI18n";

const CHECKIN_SOURCE_MANUAL = 1;
const CHECKIN_SOURCE_READER = 2;
const CHECKIN_SOURCE_APP = 3;
const CHECKIN_SOURCE_SYSTEM = 4;
const CHECKIN_SOURCE_NAME_MANUAL = "manual";
const CHECKIN_SOURCE_NAME_READER = "reader";
const CHECKIN_SOURCE_NAME_APP = "app";
const CHECKIN_SOURCE_NAME_SYSTEM = "system";

export function normalizeCheckInSource(value: string | number | null | undefined): number | null {
  if (value == null || value === "") return null;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return null;
  if (normalized === CHECKIN_SOURCE_NAME_MANUAL) return CHECKIN_SOURCE_MANUAL;
  if (normalized === CHECKIN_SOURCE_NAME_READER) return CHECKIN_SOURCE_READER;
  if (normalized === CHECKIN_SOURCE_NAME_APP) return CHECKIN_SOURCE_APP;
  if (normalized === CHECKIN_SOURCE_NAME_SYSTEM) return CHECKIN_SOURCE_SYSTEM;
  const numeric = Number(normalized);
  return Number.isFinite(numeric) ? numeric : null;
}

export function isManualCheckInSource(value: string | number | null | undefined): boolean {
  return normalizeCheckInSource(value) === CHECKIN_SOURCE_MANUAL;
}

export function formatCheckInSource(
  value: string | number | null | undefined,
  text: I18nContextValue["text"]
): string {
  switch (normalizeCheckInSource(value)) {
    case CHECKIN_SOURCE_MANUAL:
      return text("Check-in source manual");
    case CHECKIN_SOURCE_READER:
      return text("Check-in source reader");
    case CHECKIN_SOURCE_APP:
      return text("Check-in source app");
    case CHECKIN_SOURCE_SYSTEM:
      return text("Check-in source system");
    default:
      return text("—");
  }
}

export function pickCheckInSessionSource(
  checkInSource: string | number | null | undefined,
  checkOutSource: string | number | null | undefined
): string | number | null | undefined {
  const normalizedCheckOut = normalizeCheckInSource(checkOutSource);
  if (normalizedCheckOut === CHECKIN_SOURCE_SYSTEM) {
    return checkOutSource;
  }

  return checkInSource ?? checkOutSource;
}
